import axios from "axios";

// Always use relative URLs so API calls go to whatever domain the page is loaded from.
// This means the site works on any domain (preview, bruff-creative.emergent.host, bruffwrites.com).
export const API = "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage (Bearer fallback, also cookies set on login)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bruff_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = [
  { key: "childrens_books", label: "Children's Books" },
  { key: "poems", label: "Poems" },
  { key: "articles", label: "Articles" },
];

export const categoryLabel = (key) =>
  CATEGORIES.find((c) => c.key === key)?.label || key;

// Convert a relative upload URL (e.g. "/api/uploads/xxx.jpg") to a URL the browser can fetch.
// Relative paths stay relative — the browser resolves them against the current origin,
// so the same code works on preview, the old emergent.host URL, and the custom domain.
export const resolveImage = (url) => {
  if (!url) return "";
  return url;
};
